import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';

function AsiaTower() {

    return (
        <>
            <Header />
            <section id='asia-tower'>
                <div className='container'>
                    <div className='row my-5'>
                        <h4 className='text-primary text-start mb-0'>2 Bedroom Corner Unit in Asia Tower, Makati</h4>
                        <p className='text-start'> <small><i class="bi bi-pin-map-fill"></i> Paseo de Roxas, Legazpi Village, Makati</small></p>
                        <div className='row mb-3'>
                            <div className='col-lg-5'>
                                <div className='text-start'>
                                    <p className='mb-0'><b>About Asia Tower</b></p>
                                    <p>
                                        <small>
                                            Experience an exceptional residential Â lifestyle at the heart of Paseo de Roxas
                                            Ayala Land Premier by Metro Manila is a residential Â in Paseo de Roxas, one of
                                            the top cities in Makati. Ayala Land Premier provides its residents with a lifestyle
                                            of privilege that many people can only dream of. Metro Manila is yet again breaking
                                            the boundaries of residential living by bringing comfort and affordability, ensuring
                                            residents live the life they deserve as they create more amazing memories with their families.
                                            <br />
                                            <br />
                                            These makes getting a unit at Ayala Land Premier worth every cent. Properties within Makati area
                                            are quite strategically-located that's why owning a Â is a worthwhile investment one can make.
                                            <br />
                                            <br />
                                            Choosing the right location is one of the first and main factors in deciding when buying or renting
                                            a property. Ayala Land Premier is in a prime location in Makati, Paseo de Roxas, within a convenient
                                            distance from establishments like schools, churches, malls, offices and restaurants, making a
                                            Ayala Land Premier purchase perfect for those starting a family, a student or a professional looking
                                            for a place near their work and school.
                                        </small>
                                    </p>
                                </div>
                            </div>
                            <div className='col-lg-7'>
                                <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower12.jpeg'>
                                    <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower12.jpeg"
                                        className="img-fluid" alt="...">
                                    </img>
                                </a>
                                <p className='d-xxl-none d-xl-none d-xxl-block d-lg-none d-xl-block'> <small><i>Tap to Enlarge</i></small></p>
                            </div>
                        </div>
                        <div className='row mb-3'>
                            <div className='col-lg-8'>
                                <div id="AsiaTowerUnit" className="carousel slide" data-bs-ride="carousel">
                                    <div className="carousel-indicators">
                                        <button type="button" data-bs-target="#AsiaTowerUnit" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                                        <button type="button" data-bs-target="#AsiaTowerUnit" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                        <button type="button" data-bs-target="#AsiaTowerUnit" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                        <button type="button" data-bs-target="#AsiaTowerUnit" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                        <button type="button" data-bs-target="#AsiaTowerUnit" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                        <button type="button" data-bs-target="#AsiaTowerUnit" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                        <button type="button" data-bs-target="#AsiaTowerUnit" data-bs-slide-to="6" aria-label="Slide 7"></button>
                                        <button type="button" data-bs-target="#AsiaTowerUnit" data-bs-slide-to="7" aria-label="Slide 8"></button>
                                        <button type="button" data-bs-target="#AsiaTowerUnit" data-bs-slide-to="8" aria-label="Slide 9"></button>
                                    </div>
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower1.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower1.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4 className='mb-0'>Living Area</h4>
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower2.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower2.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4 className='mb-0'>Living Area</h4>
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower3.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower3.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4 className='mb-0'>Dining Area</h4>
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower4.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower4.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4 className='mb-0'>Foyer Area</h4>
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower5.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower5.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4 className='mb-0'>Kitchen Area</h4>
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower6.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower6.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4 className='mb-0'>Kitchen Area</h4>
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower7.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower7.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4 className='mb-0'>Bedroom Area</h4>
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower8.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower8.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4 className='mb-0'>Bedroom Area</h4>
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower10.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower10.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4 className='mb-0'>Bedroom Area</h4>
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                    </div>
                                    <button className="carousel-control-prev" type="button" data-bs-target="#AsiaTowerUnit" data-bs-slide="prev">
                                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Previous</span>
                                    </button>
                                    <button className="carousel-control-next" type="button" data-bs-target="#AsiaTowerUnit" data-bs-slide="next">
                                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Next</span>
                                    </button>
                                </div>
                                <p className='d-xxl-none d-xl-none d-xxl-block d-lg-none d-xl-block'> <small><i>Tap to Enlarge</i></small></p>
                            </div>
                            <div className='col-lg-4'>
                                <div className='text-start text-small'>
                                    <p className=''>
                                        <b>Easton Place</b>
                                        <br />
                                        <small>Unit: TBP</small>
                                    </p>

                                    <b>Description:</b>
                                    <ul>
                                        <li><small>2 Bedroom Unit</small></li>
                                        <li><small>Fully Furnished</small></li>
                                        <li><small>77 sq.m(828.821 sq.ft)</small></li>
                                        <li><small>2 Toilet and Bath</small></li>
                                        <li><small>Corner unit</small></li>
                                        <li><small>Parking available at additional cost</small></li>
                                    </ul>
                                    <b>Unit Features:</b>
                                    <ul>
                                        <li><small>has leather sofa</small></li>
                                        <li><small>all wooden furnitures</small></li>
                                        <li><small>has Refrigator</small></li>
                                        <li><small>has Microwave</small></li>
                                        <li><small>has gas burner</small></li>
                                    </ul>
                                    <p>
                                        <small>
                                            Available for viewing
                                            <br />
                                            <b>PhP55,000 per month</b>
                                            <br />
                                            Minimum 12 months lease
                                        </small>
                                    </p>
                                    <div className='d-flex flex-row'>
                                        <a className='btn btn-success' href='/contact-us'>Contact us for Viewing</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row mb-3'>
                            <h4 className='text-start text-primary'>Amenities and Location</h4>
                            <div className='row mb-3'>
                                <div className='col-lg-6'>
                                    <a href="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower11.jpg">
                                        <img className="img-fluid pt-4"
                                            src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower11.jpg"
                                            alt="...">
                                        </img>
                                    </a>
                                    <p className='d-xxl-none d-xl-none d-xxl-block d-lg-none d-xl-block'> <small><i>Tap to Enlarge</i></small></p>
                                </div>
                                <div className='col-lg-6'>
                                    <iframe className="embed-responsive-item"
                                        width="100%" height="400rem"
                                        src="https://maps.google.com/maps?q=asia%20tower&t=&z=17&ie=UTF8&iwloc=&output=embed"
                                        frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg- text-start'>
                                    <p className='mb-0'><b>More About Asia Tower</b></p>
                                    <p>
                                        <small>
                                            Asia Tower is a residential condominium which can be located at Benavidez St. cor. Paseo de Roxas,
                                            Legaspi Village. The Asia Tower provides a very accessible, convenient and secure office/residential
                                            condominium building in the center of Makati. It is strategically located beside the Asian Institute of
                                            Management, across the Greenbelt Mall, and a stone's throw away from major thoroughfares such as Ayala
                                            Avenue and Pasay Road. It features a swimming pool, whirlpool, social hall and other recreational facilities
                                            on the fifth floor.
                                        </small>
                                    </p>
                                    <p className='mb-0'><b>About Makati City</b></p>
                                    <p>
                                        <small>
                                            The wealthiest city in the capital region, Makati accommodates various thriving industries,
                                            including financial services, real estate, manufacturing, and business process outsourcing.
                                            Its busiest zone is the Makati Central Business District (CBD), where multinational companies
                                            are headquartered. It accommodates sprawling retail amenities and affluent villages, too. Some
                                            of the most notable, towering skyscrapers in the country are in Makati, PBCom Tower, Petron Megaplaza,
                                            and G.T. International Tower, to name a few.
                                            <br />
                                            <br />
                                            But Makati isn’t just about business and top-notch shopping. It is also a foodie destination as well
                                            as an entertainment hub for people who are looking for both high-end and laid-back cultural immersions.
                                            <br />
                                            <br />
                                            The city provides almost everything you need for a work-life balance, mainly leisure. So, if you’re
                                            traveling to Makati, here’s an ultimate guide to help you find its hidden gems.
                                        </small>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default AsiaTower